module.exports = __webpack_public_path__ + "static/media/banner1.a977c073.jpg";